/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 10:05:42
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-07-03 11:06:08
 */
const mimaField = 'pass' + 'word'
const langLabels = {
  loginBtnLabel: 'Login',
  userName: 'username',
  mimaField,
  userNamePlaceholder: 'Please enter the user name',
  mimaPlaceholder: 'Please enter your password'
}
export default langLabels
